"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStartDayOfWeek = exports.getISOWeekNum = exports.getDateWithTerminus = exports.getParsedDate = exports.getDateFormatter = exports.dateParsingFunctions = exports.getLocalizedDaysOfWeek = exports.getLastDayOfWeek = exports.getFirstDayOfWeek = exports.getLastDayOfMonth = exports.getFirstDayOfMonth = exports.areSameDates = exports.getFirstDisplayedDate = exports.getDateWithYearOffset = exports.getDateWithMonthOffset = exports.getDateWithDayOffset = exports.getDayOfWeekEnum = exports.DayOfWeek = exports.DateTerminus = void 0;
/* eslint-disable import/no-cycle */
var Localize_1 = require("../../gen-src/Localize");
var DateInputField_1 = require("../widgets/DateInputField");
var DateTerminus;
(function (DateTerminus) {
    DateTerminus[DateTerminus["Start"] = 0] = "Start";
    DateTerminus[DateTerminus["End"] = 1] = "End";
})(DateTerminus = exports.DateTerminus || (exports.DateTerminus = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sun"] = 0] = "Sun";
    DayOfWeek[DayOfWeek["Mon"] = 1] = "Mon";
    DayOfWeek[DayOfWeek["Tue"] = 2] = "Tue";
    DayOfWeek[DayOfWeek["Wed"] = 3] = "Wed";
    DayOfWeek[DayOfWeek["Thu"] = 4] = "Thu";
    DayOfWeek[DayOfWeek["Fri"] = 5] = "Fri";
    DayOfWeek[DayOfWeek["Sat"] = 6] = "Sat";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
function getDayOfWeekEnum(dayOfWeek) {
    switch (dayOfWeek) {
        case 'sun':
            return DayOfWeek.Sun;
        case 'mon':
            return DayOfWeek.Mon;
        case 'tue':
            return DayOfWeek.Tue;
        case 'wed':
            return DayOfWeek.Wed;
        case 'thu':
            return DayOfWeek.Thu;
        case 'fri':
            return DayOfWeek.Fri;
        case 'sat':
            return DayOfWeek.Sat;
        default:
            throw new Error("invalid DayOfWeekNames " + dayOfWeek);
    }
}
exports.getDayOfWeekEnum = getDayOfWeekEnum;
/*  Returns the date of the past offset days or future offset days. */
function getDateWithDayOffset(date, offset) {
    var newDate = new Date(date.getTime());
    newDate.setDate(date.getDate() + offset);
    return newDate;
}
exports.getDateWithDayOffset = getDateWithDayOffset;
/*
  Given a date, returns another date that is on the same day but in the past offset
  month or future offset month, if such day doesn't exist, returns the closest day
  in the past offset month or future offset month.
 */
function getDateWithMonthOffset(date, offset) {
    var newDate = new Date(date.getTime());
    var newMonth = date.getMonth() + offset;
    newDate.setMonth(newMonth);
    if (newDate.getDate() !== date.getDate()) {
        newDate.setDate(0);
    }
    return newDate;
}
exports.getDateWithMonthOffset = getDateWithMonthOffset;
/*
  Given a date, returns another date that is on the same day and month, but in the past
  offset year or future offset year, if such day doesn't exist, returns the closest day
  in the past offset year or future offset year.
 */
function getDateWithYearOffset(date, offset) {
    var newDate = new Date(date.getTime());
    var newYear = date.getFullYear() + offset;
    newDate.setFullYear(newYear);
    if (newDate.getMonth() !== date.getMonth()) {
        newDate.setDate(0);
    }
    return newDate;
}
exports.getDateWithYearOffset = getDateWithYearOffset;
/*
  Returns the date of the first day of current display (which might be
  different from the first day of current month).
*/
function getFirstDisplayedDate(date, firstDayOfWeek) {
    var newDate = new Date(date.getTime());
    newDate.setDate(1);
    if (newDate.getDay() < firstDayOfWeek) {
        newDate.setDate(newDate.getDate() - newDate.getDay() - 7 + firstDayOfWeek);
    }
    else {
        newDate.setDate(newDate.getDate() - newDate.getDay() + firstDayOfWeek);
    }
    return newDate;
}
exports.getFirstDisplayedDate = getFirstDisplayedDate;
/* Returns whether two date objects have the same date, ignore time */
function areSameDates(date1, date2) {
    return date1.getFullYear() === (date2 === null || date2 === void 0 ? void 0 : date2.getFullYear()) &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
}
exports.areSameDates = areSameDates;
/* Returns the date of the first day of this month */
function getFirstDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
exports.getFirstDayOfMonth = getFirstDayOfMonth;
/* Returns the date of the last day of this month */
function getLastDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
exports.getLastDayOfMonth = getLastDayOfMonth;
/* Returns the date of the first day of this week */
function getFirstDayOfWeek(date, firstDayOfWeek) {
    var newDate = new Date(date.getTime());
    if (newDate.getDay() < firstDayOfWeek) {
        newDate.setDate(newDate.getDate() - newDate.getDay() - 7 + firstDayOfWeek);
    }
    else {
        newDate.setDate(newDate.getDate() - newDate.getDay() + firstDayOfWeek);
    }
    return newDate;
}
exports.getFirstDayOfWeek = getFirstDayOfWeek;
/* Returns the date of the last day of this week */
function getLastDayOfWeek(date, firstDayOfWeek) {
    var newDate = new Date(date.getTime());
    newDate.setDate(getFirstDayOfWeek(date, firstDayOfWeek).getDate() + 6);
    return newDate;
}
exports.getLastDayOfWeek = getLastDayOfWeek;
function getLocalizedDaysOfWeek(firstDayOfWeek) {
    // July 8th, 2018 is a Sunday
    var startDate = new Date(2018, 6, 8);
    startDate.setDate(startDate.getDate() + firstDayOfWeek);
    var daysOfWeek = [];
    var daysOfWeekLength = 7;
    for (var i = 0; i < daysOfWeekLength; i++) {
        daysOfWeek.push(Localize_1.Formatters.formatNarrowDayOfWeek(getDateWithDayOffset(startDate, i)));
    }
    return daysOfWeek;
}
exports.getLocalizedDaysOfWeek = getLocalizedDaysOfWeek;
exports.dateParsingFunctions = [
    // stricter parsing functions first
    Localize_1.Parsers.parseShortDateTimeWithFullYear,
    Localize_1.Parsers.parseShortDateTimeWithFullYear24Hour,
    Localize_1.Parsers.parseShortDateMediumTimeWithFullYear,
    Localize_1.Parsers.parseShortDateMediumTimeWithFullYear24Hour,
    Localize_1.Parsers.parseShortDateTime,
    Localize_1.Parsers.parseMediumDateTime,
    Localize_1.Parsers.parseLongDateTime,
    Localize_1.Parsers.parseFullDateTime,
    Localize_1.Parsers.parseShortDate,
    Localize_1.Parsers.parseMediumDate,
    Localize_1.Parsers.parseLongDate,
    Localize_1.Parsers.parseFullDate,
    Localize_1.Parsers.parseShortDateWithFullYear,
];
function getDateFormatter(format) {
    switch (format) {
        case DateInputField_1.DateFormat.ShortDateTime:
            return Localize_1.Formatters.formatShortDateTime;
        case DateInputField_1.DateFormat.MediumDateTime:
            return Localize_1.Formatters.formatMediumDateTime;
        case DateInputField_1.DateFormat.LongDateTime:
            return Localize_1.Formatters.formatLongDateTime;
        case DateInputField_1.DateFormat.FullDateTime:
            return Localize_1.Formatters.formatFullDateTime;
        case DateInputField_1.DateFormat.ShortDate:
            return Localize_1.Formatters.formatShortDate;
        case DateInputField_1.DateFormat.MediumDate:
            return Localize_1.Formatters.formatMediumDate;
        case DateInputField_1.DateFormat.LongDate:
            return Localize_1.Formatters.formatLongDate;
        case DateInputField_1.DateFormat.FullDate:
            return Localize_1.Formatters.formatFullDate;
        case DateInputField_1.DateFormat.ShortDateWithFullYear:
            return Localize_1.Formatters.formatShortDateWithFullYear;
        case DateInputField_1.DateFormat.ShortDateTimeWithFullYear:
            return Localize_1.Formatters.formatShortDateTimeWithFullYear;
        case DateInputField_1.DateFormat.ShortDateTimeWithFullYear24Hour:
            return Localize_1.Formatters.formatShortDateTimeWithFullYear24Hour;
        case DateInputField_1.DateFormat.ShortDateMediumTimeWithFullYear:
            return Localize_1.Formatters.formatShortDateMediumTimeWithFullYear;
        case DateInputField_1.DateFormat.ShortDateMediumTimeWithFullYear24Hour:
            return Localize_1.Formatters.formatShortDateMediumTimeWithFullYear24Hour;
        default:
            throw new Error("Unsupported DateFormat: " + format);
    }
}
exports.getDateFormatter = getDateFormatter;
function getParsedDate(text, terminus) {
    var parsedFunction = null;
    var parsedDateTime = null;
    for (var i = 0; i < exports.dateParsingFunctions.length; i++) {
        var dateParsingFunction = exports.dateParsingFunctions[i];
        parsedDateTime = dateParsingFunction(text);
        if (parsedDateTime) {
            parsedFunction = dateParsingFunction;
            break;
        }
    }
    // parsedDateTime might not be a valid date object if year is too big.
    if (parsedDateTime && !isNaN(parsedDateTime.getTime())) {
        return getDateWithTerminus(parsedDateTime, parsedFunction, terminus);
    }
    else {
        return null;
    }
}
exports.getParsedDate = getParsedDate;
function getDateWithTerminus(date, parsingFunction, terminus) {
    var newDate = new Date(date.getTime());
    switch (parsingFunction) {
        case Localize_1.Parsers.parseShortDate:
        case Localize_1.Parsers.parseMediumDate:
        case Localize_1.Parsers.parseLongDate:
        case Localize_1.Parsers.parseFullDate:
        case Localize_1.Parsers.parseShortDateWithFullYear:
            if (terminus === DateTerminus.End) {
                newDate.setHours(24, 0, 0, -1);
            }
            else {
                newDate.setHours(0, 0, 0, 0);
            }
            return newDate;
        // Seconds are not defined
        case Localize_1.Parsers.parseShortDateTimeWithFullYear:
        case Localize_1.Parsers.parseShortDateTimeWithFullYear24Hour:
            if (terminus === DateTerminus.End) {
                newDate.setSeconds(60, -1);
            }
            else {
                newDate.setSeconds(0, 0);
            }
            return newDate;
        default:
            return newDate;
    }
}
exports.getDateWithTerminus = getDateWithTerminus;
function getISOWeekNum(date) {
    // https://stackoverflow.com/questions/6117814/get-week-of-year-in-javascript-like-in-php/6117889#6117889
    date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    return Math.ceil((((date.valueOf() - yearStart.valueOf()) / 86400000) + 1) / 7);
}
exports.getISOWeekNum = getISOWeekNum;
function getStartDayOfWeek(showWeekNumbers) {
    return showWeekNumbers ? DayOfWeek.Mon : getDayOfWeekEnum(Localize_1.LocaleData.get().firstDayOfWeek);
}
exports.getStartDayOfWeek = getStartDayOfWeek;
//# sourceMappingURL=Date.js.map